export default "__VITE_ASSET__7RgzC6dr__"